import React, { Fragment, useContext, useState } from "react";

import { Dialog, Transition } from "@headlessui/react";

import { ComplianceTest, ToastContext } from "common/contexts";

import ButtonNew from "components/atoms/ButtonNew";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import StepBar from "components/molecules/StepBar";

import QuizQuestion from "../QuizQuestion";
import { ResultScreen } from "../ResultScreen";

const dataStep = [
  {
    id: 1,
    name: "Questionnaire",
    sub_step: [],
  },
  {
    id: 2,
    name: "Result",
    sub_step: [],
  },
];

export default function QuizSection({ data, country }) {
  const {
    dataCompliance,
    questionIndex,
    setQuestionIndex,
    childrenShow,
    setChildrenShow,
    dataChildren,
    fromChildren,
    setFromChildren,
    reset,
  } = useContext(ComplianceTest);
  const [step, setStep] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const { openAlert, setOpenAlert } = useContext(ToastContext);

  const handleBackToTool = () => {
    openAlert(false, "custom", {
      bgAlert: "bg-white",
      element: (
        <>
          <Img
            src="/assets/icons/warning.png"
            width={98}
            height={100}
            alt="icon error"
            className="mx-auto mb-6"
            wrapper={{
              className: "block",
            }}
          />
          <p className="mb-6 text-2xl font-semibold text-bbc-brand-700">
            Are you sure?{" "}
          </p>
          <div className="flex justify-around">
            <ButtonNew
              variant="outline"
              btnTextColor={"text-bbc-red-300 hover:text-white"}
              btnBorder={"border border-bbc-red-300 hover:border-bbc-red-400"}
              btnColor={"bg-transparent hover:bg-bbc-red-400"}
              othersClass={"w-28"}
              onClick={() => {
                setOpenAlert(false);
              }}
            >
              No
            </ButtonNew>
            <ButtonNew
              othersClass={"w-28"}
              onClick={() => {
                reset();
                setOpenAlert(false);
              }}
            >
              Yes
            </ButtonNew>
          </div>
        </>
      ),
    });
  };
  const handleBackQuestion = () => {
    setQuestionIndex(
      childrenShow
        ? questionIndex
        : questionIndex - 1 < 0
        ? 0
        : questionIndex - 1
    );
    setChildrenShow(fromChildren);
    setFromChildren(false);
  };
  const renderSection = () => {
    if (questionIndex === data?.question_list?.length) {
      return (
        <ResultScreen
          data={[...dataCompliance, ...(data.default_compliance || [])]}
          itemData={data}
          setStep={setStep}
          btnBack={
            data?.question_list?.length > 0 && (
              <div
                className={
                  " inline-block border-0 bg-transparent p-0 font-medium text-bbc-brand-500 focus:outline-none"
                }
              >
                <button
                  className="mt-6 inline-block border-0 bg-transparent p-0 font-medium text-bbc-neutral-600 focus:outline-none"
                  onClick={() => {
                    handleBackQuestion();
                    setStep(1);
                  }}
                >
                  Back
                </button>
              </div>
            )
          }
        />
      );
    }
    if (childrenShow) {
      if (dataChildren.length > 0) {
        return dataChildren.map((data, index) => (
          <QuizQuestion key={index + data.question} question={data} />
        ));
      }
    } else {
      if (questionIndex > 0 || childrenShow) {
        return (
          <>
            <QuizQuestion
              question={
                data?.question_list[questionIndex]
                  ? data?.question_list[questionIndex]
                  : {}
              }
            />

            <button
              onClick={() => handleBackQuestion()}
              className="mt-6 inline-block border-0 bg-transparent p-0 font-medium text-bbc-neutral-600 focus:outline-none"
            >
              Back
            </button>
          </>
        );
      }

      return (
        <QuizQuestion
          question={
            data?.question_list[questionIndex]
              ? data?.question_list[questionIndex]
              : {}
          }
        />
      );
    }
  };

  return (
    <div
      className={
        "lg:shadow-bbc w-full lg:rounded-xl lg:bg-white lg:py-10 lg:px-24  "
      }
    >
      <div className="mb-6 flex justify-between">
        <div>
          <div className={"mr-3 inline-block"}>
            <button
              className="inline-block border-0 bg-transparent p-0 font-medium text-bbc-brand-500 focus:outline-none"
              onClick={handleBackToTool}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <h2 className="mb-6 text-center text-2xl font-bold text-bbc-brand-700">
        {country.label} <br />
        Annual Compliance Guide
      </h2>
      <div className="text-center">
        <StepBar step={step} data={dataStep} />
      </div>
      {renderSection()}
      <>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsOpen(false)}
            style={{ zIndex: 51 }}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-[rgba(0,0,0,.4)]" />
              </Transition.Child>
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="my-8 inline-block w-full max-w-lg transform overflow-hidden rounded-[10px] bg-white px-6 py-10 text-center align-middle shadow-xl transition-all">
                  <Img
                    src="/assets/images/offshore/guide-and-tool/es-tool/warning-es_tool.svg"
                    width={128}
                    height={109}
                    alt="warning"
                  />
                  <Title
                    text="Are you sure?"
                    className="mt-6 text-lg font-medium text-bbc-brand-700 lg:text-2xl lg:font-semibold lg:leading-9"
                  />
                  <div className="mt-6 flex justify-center gap-x-6">
                    <ButtonNew
                      onClick={() => setIsOpen(false)}
                      btnColor="bg-bbc-neutral-600 hover:bg-bbc-neutral-700"
                      othersClass=" min-w-[109px] font-medium"
                    >
                      No
                    </ButtonNew>
                    <ButtonNew
                      onClick={() => handleBackToTool()}
                      othersClass="min-w-[109px] font-medium"
                    >
                      Yes
                    </ButtonNew>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </>
    </div>
  );
}
